<template>
  <div
    class="page dashboard"
    style="position:relative"
  >
    <VtLoading v-if="loading" />
    <div
      style="width: 100%;"
      class="grid-scroll"
    >
      <div class="dashboard-container">
        <grid-layout
          v-if="smallWidgetsActivated.length"
          class="pb-4 xl-margin"
          :layout.sync="smallWidgetsActivated"
          :margin="[20, 10]"
          :auto-size="true"
          :row-height="30"
          :is-draggable="true"
          :is-resizable="false"
          :is-mirrored="false"
          :vertical-compact="false"
          :use-css-transforms="false"
          :prevent-collision="true"
          :responsive="true"
          :breakpoints="{ md: 1200, sm: 768, xs: 480, xxs: 0 }"
          :cols="{ md: 12, sm: 6, xs: 4, xxs: 2 }"
        >
          <grid-item
            v-for="itemSmallWidgetsActivated in smallWidgetsActivated"
            :key="itemSmallWidgetsActivated.i"
            :class="[itemSmallWidgetsActivated.color, itemSmallWidgetsActivated.type, {'hidden':itemSmallWidgetsActivated.hidden, 'widget-disabled': itemSmallWidgetsActivated.disabled}]"
            :x="itemSmallWidgetsActivated.x"
            :y="itemSmallWidgetsActivated.y"
            :w="itemSmallWidgetsActivated.w"
            :h="itemSmallWidgetsActivated.h"
            :i="itemSmallWidgetsActivated.i"
            @moved="saveLayout()"
          >
            <info-widget
              v-if="itemSmallWidgetsActivated.type === 'info-widget'"
              :item="itemSmallWidgetsActivated"
              :laboratory-id="labId"
              @hideItemLayout="hideSmallWidget(itemSmallWidgetsActivated)"
            />

            <link-widget
              v-if="itemSmallWidgetsActivated.type === 'link-widget'"
              :item="itemSmallWidgetsActivated"
              @hideItemLayout="hideSmallWidget(itemSmallWidgetsActivated)"
              @showPatientModal="showPatientModal()"
            />

            <scan-widget
              v-if="itemSmallWidgetsActivated.type === 'scan-widget'"
              :item="itemSmallWidgetsActivated"
              @openWidgetConfigurationSidepanel="toggleWidgetConfigurationSidePanel(itemSmallWidgetsActivated)"
              @hideItemLayout="hideSmallWidget(itemSmallWidgetsActivated)"
            />
          </grid-item>
        </grid-layout>
        <transition name="fade">
          <div v-if="smallWidgetsActivated.length">
            <hr class="dashboard-line-separator">
          </div>
        </transition>
        <grid-layout
          v-if="bigWidgetsActivated.length"
          class="xl-margin"
          :layout.sync="bigWidgetsActivated"
          :margin="[20, 10]"
          :auto-size="true"
          :row-height="40"
          :is-draggable="true"
          :is-resizable="false"
          :is-mirrored="false"
          :vertical-compact="false"
          :use-css-transforms="false"
          :prevent-collision="true"
          :responsive="true"
          :breakpoints="{ md: 1200, sm: 768, xs: 480, xxs: 0 }"
          :cols="{ md: 12, sm: 6, xs: 4, xxs: 2 }"
        >
          <grid-item
            v-for="itemBigWidgetsActivated in bigWidgetsActivated"
            :key="itemBigWidgetsActivated.i"
            :class="[itemBigWidgetsActivated.color, itemBigWidgetsActivated.type, {'hidden':itemBigWidgetsActivated.hidden, 'widget-disabled': itemBigWidgetsActivated.disabled}]"
            :x="itemBigWidgetsActivated.x"
            :y="itemBigWidgetsActivated.y"
            :w="itemBigWidgetsActivated.w"
            :h="itemBigWidgetsActivated.h"
            :i="itemBigWidgetsActivated.i"
            @moved="saveLayout()"
          >
            <chart-widget
              v-if="itemBigWidgetsActivated.type === 'chart-widget'"
              ref="chartWidget"
              :item="itemBigWidgetsActivated"
              :update="true"
              @toggleWidgetConfigurationSidepanel="toggleWidgetConfigurationSidePanel(itemBigWidgetsActivated)"
              @hideItemLayout="hideBigWidget(itemBigWidgetsActivated)"
            />
            <print-widget
              v-if="itemBigWidgetsActivated.type === 'print-widget'"
              :widget="itemBigWidgetsActivated"
              @hideItemLayout="hideBigWidget(itemBigWidgetsActivated)"
            />
          </grid-item>
        </grid-layout>
        <b-button
          class="btn__floating setup-btn d-flex align-items-center justify-content-center"
          @click="sidebarOpen=!sidebarOpen"
        >
          <i
            class="fal fa-sliders-h"
            aria-hidden="true"
          />
        </b-button>
      </div>
    </div>
    <div
      v-if="sidebarOpen"
      v-click-outside="onClickOutsideSidePanel"
      class="widget-bar"
      :class="{'bar-active': sidebarOpen}"
    >
      <div class="p-3 d-flex justify-content-between">
        <div>
          <i
            class="fas fa-th-large mr-2"
            aria-hidden="true"
          />
          <span>{{ $tc('dashboard.sidepanel.widget',2) }}</span>
        </div>
        <b-button
          v-shortkey="['shift', 'esc']"
          class="btn-white btn__icon btn__icon--primary px-1 py-0"
          @click="sidebarOpen = !sidebarOpen"
          @shortkey.prevent="sidebarOpen = !sidebarOpen"
        >
          <i
            class="fal fa-times"
            aria-hidden="true"
          />
        </b-button>
      </div>
      <div class="content-scroll">
        <b-row
          v-if="visibleSectionClinical"
          class="px-3 mb-2"
        >
          <div class="px-2 w-100">
            <div class="dashboard-section-header">
              <span>{{ $t('dashboard.sidepanel.requests') }}</span>
            </div>
          </div>
          <b-col
            v-for="itemLayoutSectionClinical in layoutSectionClinical"
            :key="itemLayoutSectionClinical.i"
            cols="4"
            class="p-1"
          >
            <div
              v-if="itemLayoutSectionClinical.type === 'scan-widget' ? hasOperationInAnyLaboratoryGlobalMixin(requestOperation.CREATE) : true"
              class="module-items p-1"
              :class="{'btn-disabled': itemLayoutSectionClinical.disabled}"
            >
              <b-button
                v-tooltip="$t(itemLayoutSectionClinical.label)"
                :class="{'widget-actived':!itemLayoutSectionClinical.hidden}"
                block
                class="text-center"
                @click="showItemLayoutSmallWidget(itemLayoutSectionClinical)"
              >
                <i
                  :class="itemLayoutSectionClinical.icon"
                  aria-hidden="true"
                />
              </b-button>
            </div>
          </b-col>
        </b-row>
        <b-row
          v-if="visibleSectionRequest"
          class="px-3 mb-2"
        >
          <div class="px-2 w-100">
            <div class="dashboard-section-header">
              <span>{{ $t('dashboard.sidepanel.requestsMailbox') }}</span>
            </div>
          </div>
          <b-col
            v-for="itemLayoutSectionRequest in layoutSectionRequest"
            :key="itemLayoutSectionRequest.i"
            cols="4"
            class="p-1"
          >
            <div class="module-items p-1">
              <b-button
                v-tooltip="$t(itemLayoutSectionRequest.label)"
                :class="{'widget-actived':!itemLayoutSectionRequest.hidden}"
                block
                class="text-center"
                @click="showItemLayoutSmallWidget(itemLayoutSectionRequest)"
              >
                <i
                  :class="itemLayoutSectionRequest.icon"
                  aria-hidden="true"
                />
              </b-button>
            </div>
          </b-col>
        </b-row>
        <b-row
          v-if="visibleSectionRegistry"
          class="px-3 mb-2"
        >
          <div class="px-2 w-100">
            <div class="dashboard-section-header">
              <span>{{ $t('dashboard.sidepanel.registry') }}</span>
            </div>
          </div>
          <b-col
            v-for="itemLayoutSectionRegistry in layoutSectionRegistry"
            :key="itemLayoutSectionRegistry.i"
            cols="4"
            class="p-1"
          >
            <div
              v-if="itemLayoutSectionRegistry.type === 'scan-widget' ? hasLabOperationGlobalMixin(labId, caseOperation.CREATE) : true"
              class="module-items p-1"
            >
              <b-button
                v-tooltip="$t(itemLayoutSectionRegistry.label)"
                :class="{'widget-actived':!itemLayoutSectionRegistry.hidden}"
                block
                class="text-center"
                @click="itemLayoutSectionRegistry.type === 'print-widget' ? showItemLayoutBigWidget(itemLayoutSectionRegistry) : showItemLayoutSmallWidget(itemLayoutSectionRegistry)"
              >
                <i
                  :class="itemLayoutSectionRegistry.icon"
                  aria-hidden="true"
                />
              </b-button>
            </div>
          </b-col>
        </b-row>
        <b-row
          v-if="visibleSectionGrossing"
          class="px-3 mb-2"
        >
          <div class="px-2 w-100">
            <div class="dashboard-section-header">
              <span>{{ $t('dashboard.sidepanel.grossing') }}</span>
            </div>
          </div>
          <b-col
            v-for="itemLayoutSectionGrossing in layoutSectionGrossing"
            :key="itemLayoutSectionGrossing.i"
            cols="4"
            class="p-1"
          >
            <div class="module-items p-1">
              <b-button
                v-tooltip="$t(itemLayoutSectionGrossing.label)"
                :class="{'widget-actived':!itemLayoutSectionGrossing.hidden}"
                block
                class="text-center"
                @click="showItemLayoutSmallWidget(itemLayoutSectionGrossing)"
              >
                <i
                  :class="itemLayoutSectionGrossing.icon"
                  aria-hidden="true"
                />
              </b-button>
            </div>
          </b-col>
        </b-row>
        <b-row
          v-if="visibleSectionDiagnosis"
          class="px-3 mb-2"
        >
          <div class="px-2 w-100">
            <div class="dashboard-section-header">
              <span>{{ $t('dashboard.sidepanel.diagnosis') }}</span>
            </div>
          </div>
          <b-col
            v-for="itemLayoutSectionDiagnosis in layoutSectionDiagnosis"
            :key="itemLayoutSectionDiagnosis.i"
            cols="4"
            class="p-1"
          >
            <div class="module-items p-1">
              <b-button
                v-tooltip.html="`${$t(itemLayoutSectionDiagnosis.prelabel)}:<br>${$t(itemLayoutSectionDiagnosis.label)}`"
                :class="{'widget-actived':!itemLayoutSectionDiagnosis.hidden}"
                block
                class="text-center"
                @click="showItemLayoutBigWidget(itemLayoutSectionDiagnosis)"
              >
                <i
                  :class="itemLayoutSectionDiagnosis.icon"
                  aria-hidden="true"
                />
              </b-button>
            </div>
          </b-col>
        </b-row>
        <b-row
          v-if="visibleSectionLaboratory"
          class="px-3 mb-2"
        >
          <div class="px-2 w-100">
            <div class="dashboard-section-header">
              <span>{{ $tc('global.laboratory') }}</span>
            </div>
          </div>
          <b-col
            v-for="itemLayoutSectionLaboratory in layoutSectionLaboratory"
            :key="itemLayoutSectionLaboratory.i"
            cols="4"
            class="p-1"
          >
            <div class="module-items p-1">
              <b-button
                v-tooltip="$t(itemLayoutSectionLaboratory.label)"
                :class="{'widget-actived':!itemLayoutSectionLaboratory.hidden}"
                block
                class="text-center"
                @click="showItemLayoutSmallWidget(itemLayoutSectionLaboratory)"
              >
                <i
                  :class="itemLayoutSectionLaboratory.icon"
                  aria-hidden="true"
                />
              </b-button>
            </div>
          </b-col>
        </b-row>
        <b-row
          v-if="visibleSectionIncidents"
          class="px-3 mb-2"
        >
          <div class="px-2 w-100">
            <div class="dashboard-section-header">
              <span>{{ $t('dashboard.sidepanel.incidents') }}</span>
            </div>
          </div>
          <b-col
            v-for="itemLayoutSectionIncidents in layoutSectionIncidents"
            :key="itemLayoutSectionIncidents.i"
            cols="4"
            class="p-1"
          >
            <div class="module-items p-1">
              <b-button
                v-tooltip="$t(itemLayoutSectionIncidents.label)"
                :class="{'widget-actived':!itemLayoutSectionIncidents.hidden}"
                block
                class="text-center"
                @click="showItemLayoutSmallWidget(itemLayoutSectionIncidents)"
              >
                <i
                  :class="itemLayoutSectionIncidents.icon"
                  aria-hidden="true"
                />
              </b-button>
            </div>
          </b-col>
        </b-row>
        <b-row
          v-if="visibleSectionWaste"
          class="px-3 mb-2"
        >
          <div class="px-2 w-100">
            <div class="dashboard-section-header">
              <span>{{ $t('dashboard.sidepanel.waste') }}</span>
            </div>
          </div>
          <b-col
            v-for="itemLayoutSectionWaste in layoutSectionWaste"
            :key="itemLayoutSectionWaste.i"
            cols="4"
            class="p-1"
          >
            <div class="module-items p-1">
              <b-button
                v-tooltip="$t(itemLayoutSectionWaste.label)"
                :class="{'widget-actived':!itemLayoutSectionWaste.hidden}"
                block
                class="text-center"
                @click="showItemLayoutSmallWidget(itemLayoutSectionWaste)"
              >
                <i
                  :class="itemLayoutSectionWaste.icon"
                  aria-hidden="true"
                />
              </b-button>
            </div>
          </b-col>
        </b-row>
        <!--TODO: Comentado de momento a espera de dedicision definitiva -->
        <!--<b-row class="px-3 mb-2" v-if="!userInformation.isPetitioner">
                    <div class="px-2 w-100">
                        <div class="dashboard-section-header">
                            <span>{{$t('dashboard.sidepanel.others')}}</span>
                        </div>
                    </div>
                    <b-col v-for="item in layoutSectionOthers" :key="item.i" cols="4" class="p-1">
                        <div class="module-items p-1">
                            <b-button
                                    :class="{'widget-actived':!item.hidden}"
                                    @click="showItemLayoutSmallWidget(item)"
                                    block
                                    class="text-center"
                                    v-tooltip="item.label"
                            >
                                <i :class="item.icon" aria-hidden="true"></i>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>-->
      </div>
    </div>
    <vt-side-panel
      v-if="showWidgetConfigurationSidepanel"
      :visible="showWidgetConfigurationSidepanel"
    >
      <widget-configuration-sidepanel
        ref="widgetConfigurationSidepanel"
        :item="item"
        @closeWidgetConfigurationSidepanel="closeWidgetConfigurationSidePanel()"
        @addFilter="onAddFilter($event)"
      />
    </vt-side-panel>
    <modal-states
      id="modalStates"
      ref="statesModal"
    />
    <modal-wrapper ref="searchPatientModal">
      <search-patient-modal id-modal="searchPatientModal" />
    </modal-wrapper>
  </div>
</template>

<script>
import ModalStates from '@/components/modals/ModalStates'
import VtLoading from '@/components/common/VtLoading'
import { GridItem, GridLayout } from 'vue-grid-layout'
import SearchPatientModal from '@/components/searcherPatientModal/SearchPatientModal'
import customConfigResource from '@/api/resources/ui/CustomConfigResource'
import InfoWidget from '@/modules/dashboardModule/widgets/InfoWidget'
import LinkWidget from '@/modules/dashboardModule/widgets/LinkWidget'
import ScanWidget from '@/modules/dashboardModule/widgets/scan-widget/scan-widget.vue'
import ChartWidget from '@/modules/dashboardModule/widgets/chartWidget/ChartWidget'
import PrintWidget from '@/modules/dashboardModule/widgets/PrintWidget'
import { RequestOperation } from '@/api/operations/models/request-operation'
import { CaseOperation } from '@/api/operations/models/case-operation'
import { ModuleOperation } from '@/api/operations/models/module-operation'
import WidgetConfigurationSidepanel from '@/modules/dashboardModule/WidgetConfigurationSidepanel'
import { keyBy, merge, pick } from 'lodash'
import { PortionOperation } from '@/api/operations/models/portion-operation'
import { SubportionOperation } from '@/api/operations/models/subportion-operation'
import { dashboardLayout } from '@/modules/dashboardModule/dashboard-layout'
import { DashboardSection, DashboardWidgetOption } from '@/modules/dashboardModule/dashboard-view.model'
import { HelperUtils } from '@/shared/util/helper-utils'

export default {
    name: 'Home',
    components: {
        ScanWidget,
        LinkWidget,
        InfoWidget,
        GridLayout: GridLayout,
        GridItem: GridItem,
        ModalStates,
        VtLoading,
        SearchPatientModal,
        ChartWidget,
        PrintWidget,
        WidgetConfigurationSidepanel
    },
    data() {
        return {
            requestOperation: RequestOperation,
            caseOperation: CaseOperation,
            smallWidgetsActivated: [],
            bigWidgetsActivated: [],
            uiComponent: 'uicomponent.dashboard',
            sidebarOpen: false,
            loading: false,
            showWidgetConfigurationSidepanel: false,
            layout: dashboardLayout(),
            item: {}
        }
    },
    computed: {
        labId() {
            return this.$store.getters.labId
        },
        userInformation() {
            return this.$store.getters.userInformation
        },

        layoutSectionClinical() {
            return this.layout.filter(widget => widget.section === DashboardSection.CLINICAL)
        },
        visibleSectionClinical() {
            return !!this.layoutSectionClinical.length &&
                this._hasSectionAccess(DashboardSection.CLINICAL)
        },

        layoutSectionRequest() {
            return this.layout.filter(widget => widget.section === DashboardSection.REQUEST)
        },
        visibleSectionRequest() {
            return !!this.layoutSectionRequest.length &&
                this._hasSectionAccess(DashboardSection.REQUEST)
        },

        layoutSectionRegistry() {
            return this.layout.filter(
                widget => widget.section === DashboardSection.REGISTRY &&
                    (widget.type === 'scan-widget'
                        ? this.hasLabOperationGlobalMixin(this.labId, this.caseOperation.CREATE)
                        : true))
        },
        visibleSectionRegistry() {
            return !!this.layoutSectionRegistry.length &&
                this._hasSectionAccess(DashboardSection.REGISTRY)
        },

        layoutSectionGrossing() {
            return this.layout.filter(widget => widget.section === DashboardSection.GROSSING)
        },
        visibleSectionGrossing() {
            return !!this.layoutSectionGrossing.length &&
                this._hasSectionAccess(DashboardSection.GROSSING)
        },

        layoutSectionWaste() {
            return this.layout.filter(widget => widget.section === DashboardSection.WASTE)
        },
        visibleSectionWaste() {
            return !!this.layoutSectionWaste.length &&
                this._hasSectionAccess(DashboardSection.WASTE)
        },

        layoutSectionIncidents() {
            return this.layout.filter(widget => widget.section === DashboardSection.INCIDENTS)
        },
        visibleSectionIncidents() {
            return !!this.layoutSectionIncidents.length &&
                this._hasSectionAccess(DashboardSection.INCIDENTS)
        },

        layoutSectionOthers() {
            return this.layout.filter(widget => widget.section === DashboardSection.OTHERS)
        },
        visibleSectionOthers() {
            return !this.layoutSectionOthers.length
        },

        layoutSectionDiagnosis() {
            return this.layout.filter(widget => widget.section === DashboardSection.DIAGNOSIS)
        },
        visibleSectionDiagnosis() {
            return !!this.layoutSectionDiagnosis.length &&
                this._hasSectionAccess(DashboardSection.DIAGNOSIS)
        },

        layoutSectionLaboratory() {
            const laboratorySectionWidgets = this.layout.filter(widget => widget.section === DashboardSection.LABORATORY)
            return laboratorySectionWidgets.filter(laboratorySectionWidget => {
                switch (laboratorySectionWidget.widgetOption) {
                case DashboardWidgetOption.PORTION_MAKE:
                    return this.$_hasOperationInCurrentLaboratory(PortionOperation.MAKE)
                case DashboardWidgetOption.PORTION_CUT:
                    return this.$_hasOperationInCurrentLaboratory(PortionOperation.CUT)
                case DashboardWidgetOption.SUBPORTION_TO_SCANNER:
                    return this.$_hasOperationInCurrentLaboratory(SubportionOperation.TO_SCANNER)
                default:
                    return true
                }
            })
        },
        visibleSectionLaboratory() {
            return !!this.layoutSectionLaboratory.length &&
                this._hasSectionAccess(DashboardSection.LABORATORY)
        }
    },
    async mounted() {
        const layoutUiComponent = await customConfigResource.get(this.uiComponent)
        if (layoutUiComponent) {
            this.smallWidgetsActivated = this._loadWidgets(layoutUiComponent.config.smallWidgetsActivated)
            this.bigWidgetsActivated = this._loadWidgets(layoutUiComponent.config.bigWidgetsActivated)
        }
    },
    methods: {
        _hasSectionAccess(section) {
            switch (section) {
            case DashboardSection.CLINICAL:
                return HelperUtils.hasModuleAccess(ModuleOperation.PETITIONER)
            case DashboardSection.REQUEST:
                return HelperUtils.hasModuleAccess(ModuleOperation.REGISTRY_REQUEST)
            case DashboardSection.REGISTRY:
                return HelperUtils.hasModuleAccess(ModuleOperation.REGISTRY)
            case DashboardSection.GROSSING:
                return HelperUtils.hasModuleAccess(ModuleOperation.GROSSING)
            case DashboardSection.WASTE:
                return HelperUtils.hasModuleAccess(ModuleOperation.WASTE)
            case DashboardSection.INCIDENTS:
                return HelperUtils.hasModuleAccess(ModuleOperation.INCIDENT)
            case DashboardSection.DIAGNOSIS:
                return HelperUtils.hasModuleAccess(ModuleOperation.DIAGNOSE)
            case DashboardSection.LABORATORY:
                return HelperUtils.hasModuleAccess(ModuleOperation.LABORATORY)
            default:
                return false
            }
        },
        onAddFilter(item) {
            this.getUiComponentDataAndFillChartData(item.uicomponent)
        },
        getUiComponentDataAndFillChartData(uiComponent) {
            if (this.$refs.chartWidget.length) {
                this.$refs.chartWidget.forEach(chartWidgetComponent => {
                    chartWidgetComponent.$refs.caseDelayedChartContainer?.getUiComponentDataAndFillChartData(uiComponent)
                })
            }
        },
        onClickOutsideSidePanel() {
            this.sidebarOpen = false
        },
        _loadWidgets(userWidgets) {
            const userWidgetsKeys = userWidgets.map(widget => widget.i)
            const layoutWidgets =
                this.layout.filter(widget =>
                    userWidgetsKeys.includes(widget.i) &&
                    this._hasSectionAccess(widget.section))
            const layoutWidgetsKeys = layoutWidgets.map(widget => widget.i)
            return Object.values(
                merge(
                    keyBy(layoutWidgets, 'i'),
                    keyBy(userWidgets.filter(widget => layoutWidgetsKeys.includes(widget.i)), 'i')))
        },
        async saveLayout() {
            await customConfigResource.save(this.uiComponent, {
                smallWidgetsActivated: this.smallWidgetsActivated.map(smallWidgetActivated => pick(smallWidgetActivated, [ 'x', 'y', 'w', 'h', 'i', 'hidden' ])),
                bigWidgetsActivated: this.bigWidgetsActivated.map(bigWidgetActivated => pick(bigWidgetActivated, [ 'x', 'y', 'w', 'h', 'i', 'hidden' ]))
            })
        },
        async showItemLayoutBigWidget(item) {
            if (!item.hidden) {
                await this.hideBigWidget(item)
                return
            }
            const lastElement = this.bigWidgetsActivated[this.bigWidgetsActivated.length - 1]
            if (lastElement) {
                if (lastElement.x === 10 || lastElement.x === 9 || lastElement.x === 8) {
                    item.x = 0
                    item.y = lastElement.y + 8
                } else {
                    item.x = lastElement.x + 3
                    item.y = lastElement.y
                }
            } else {
                item.x = 0
                item.y = 0
            }
            item.hidden = false
            this.bigWidgetsActivated.push(item)
            await this.saveLayout()
        },
        async showItemLayoutSmallWidget(item) {
            if (!item.hidden) {
                await this.hideSmallWidget(item)
                return
            }
            const lastElement = this.smallWidgetsActivated[this.smallWidgetsActivated.length - 1]
            if (lastElement) {
                if (lastElement.x === 10 || lastElement.x === 9) {
                    item.x = 0
                    item.y = lastElement.y + 2
                } else {
                    item.x = lastElement.x + 2
                    item.y = lastElement.y
                }
            } else {
                item.x = 0
                item.y = 0
            }
            item.hidden = false
            this.smallWidgetsActivated.push(item)
            await this.saveLayout()
        },
        async hideSmallWidget(item) {
            item.hidden = true
            const itemIndex = this.smallWidgetsActivated.findIndex((widget) => widget.i === item.i)
            const itemLayout = this.layout.find(widget => widget.i === item.i)
            itemLayout.hidden = true
            this.smallWidgetsActivated.splice(itemIndex, 1)
            await this.saveLayout()
        },
        async hideBigWidget(item) {
            item.hidden = true
            const itemIndex = this.bigWidgetsActivated.findIndex(widget => widget.i === item.i)
            const itemLayout = this.layout.find(widget => widget.i === item.i)
            itemLayout.hidden = true
            this.bigWidgetsActivated.splice(itemIndex, 1)
            this.closeWidgetConfigurationSidePanel()
            await this.saveLayout()
        },
        showPatientModal() {
            this.$refs.searchPatientModal.show()
        },
        closeWidgetConfigurationSidePanel() {
            this.showWidgetConfigurationSidepanel = false
        },
        toggleWidgetConfigurationSidePanel(item) {
            this.showWidgetConfigurationSidepanel = !this.showWidgetConfigurationSidepanel
            this.item = item
        }
    }
}
</script>

<style lang="scss">

    .vue-grid-item.cssTransforms { transition-property: inherit !important; }
    .vue-resizable.resizing { pointer-events: none; }
    .vue-draggable-dragging { pointer-events: none; }
    .vue-grid-item.vue-draggable-dragging { transition:none; z-index: 3; }

    .page.dashboard .preloader {
        position: relative;
        overflow: hidden;
        background: vt-color(preloader, .4);
    }
    .page.dashboard .preloader:after {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        animation-duration: 0.6s;
        animation-iteration-count: infinite;
        animation-name: loader-animate;
        animation-timing-function: linear;
        background: -webkit-linear-gradient(left, rgba(255,255,255,0) 0%, rgba(255,255,255,0.6) 30%, rgba(255,255,255,0) 81%);
        background: -o-linear-gradient(left, rgba(255,255,255,0) 0%, rgba(255,255,255,0.6) 30%, rgba(255,255,255,0) 81%);
        background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,0.6) 30%, rgba(255,255,255,0) 81%);
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#00ffffff',GradientType=1 );
    }
    // Preloader animation
    @keyframes loader-animate{
        0%{
            transform: translate3d(-100%, 0, 0);
        }
        100%{
            transform: translate3d(100%, 0, 0);
        }
    }

    .print-template-pop {
        padding: 0 !important;
    }
    .print-template-pop ul {
        padding: 0;
        margin: 5px 0;
    }

    .print-template-pop ul li {
        list-style: none;
        padding: 2px 20px;
        font-size: 12px;
        cursor: pointer;
    }

    .print-template-pop ul li:hover {
        background: vt-color(light-primary);
    }

    .print-template-pop .pop-header {
        background: vt-color(base-text, .9);
        padding: 8px 12px;
        font-weight: 700;
    }

    .page.dashboard{
        overflow-x: hidden;
    }

    .page.dashboard .vt-side-panel {
        width: 350px;
        overflow-y: auto;
    }

    .page.dashboard .dashboard-line-separator {
        margin: 10px 15px;
        border-color: vt-color(general-border, .5);
    }

    .page.dashboard .multiselect__tags{
        overflow: hidden;
        display: flex;
    }

    .page.dashboard .form-icon{
        width: 30px;
        cursor: pointer;
    }

    .page.dashboard .form-icon i{
        font-size: 16px;
    }

    .page.dashboard .bubble{
        position:absolute;
        bottom: 0;
        right: 1px;
    }

    .page.dashboard .switch-label {
        font-size: font-size(very-small);
        color: vt-color(dark-text);
    }

    .page.dashboard .switch {
        position: relative;
        display: inline-block;
        width: 30px;
        height: 16px;
        background-color: rgba(0, 0, 0, 0.25);
        border-radius: 20px;
        transition: all 0.3s;
        cursor: pointer;
    }

    .page.dashboard .switch::after {
        content: "";
        position: absolute;
        width: 14px;
        height: 14px;
        border-radius: 14px;
        background-color: white;
        top: 1px;
        left: 1px;
        transition: all 0.3s;
    }

    .page.dashboard input[type="checkbox"]:checked + .switch::after {
        transform: translateX(14px);
    }

    .page.dashboard input[type="checkbox"]:checked + .switch {
        background-color: vt-color(primary);
    }

    .page.dashboard .offscreen {
        position: absolute;
        left: -9999px;
    }

    .page.dashboard .button-transparent{
        background: transparent !important;
        border-color: transparent !important;
        padding: 0 !important;
    }

    .page.dashboard .button-transparent:hover{
        color: vt-color(dark-primary);
    }

    .info-widget.widget-disabled,
    .scan-widget.widget-disabled,
    .link-widget.widget-disabled {
        background: vt-color(base-text, .6) !important;
    }

    .page.dashboard .dashboard-section-header {
        background: rgba(vt-color(dark-primary), 0.5);
        padding: 3px;
        font-size: font-size(very-tiny);
        text-transform: uppercase;
        display: flex;
        align-items: center;
        justify-content: center;
        color: rgba(vt-color(white-light), 0.7);
        border-radius: 3px;
        width: 100%;
    }

    .page.dashboard .hidden {
        display: none;
    }

    .btn-white {
        color: vt-color(white-light) !important;
    }

    .page.dashboard .chart-widget,
    .page.dashboard .scan-widget,
    .page.dashboard .print-widget, {
        background: rgba(vt-color(white-light), 0.98);
        cursor: pointer;
        @include general-card();
    }

    .page.dashboard .chart-widget:before {
        content: '';
        position: absolute;
        width: 4px;
        height: 100%;
        background: rgb(79, 208, 240);
        top: 0;
        left: 0;
        border-radius: 5px 0 0 5px;
    }

    .page.dashboard .scan-widget:before {
        content: '';
        position: absolute;
        width: 4px;
        height: 100%;
        background: #eac696;
        top: 0;
        left: 0;
        border-radius: 5px 0 0 5px;
    }

    .page.dashboard .chart-widget .multiselect__content-wrapper {
        max-height: 400px !important;
    }

    .page.dashboard .chart-widget .multiselect__option--selected {
        background-color: vt-color(green-radiant, .7) !important;
    }

    .page.dashboard .chart-widget .multiselect__option--selected:hover {
        background-color: vt-color(green-radiant, .5) !important;
    }

    .page.dashboard .chart-widget .multiselect__option.multiselect__option--highlight {
        background-color: transparent;
        color: grey;
    }

    .page.dashboard .chart-widget .multiselect__option:hover {
        background-color: vt-color(light-primary);
        color: grey;
    }

    .page.dashboard .chart-widget .multiselect__tags-wrap {
        display: none;
    }

    .page.dashboard .print-widget > div {
        height: 100%;
        position: relative;
    }
    .page.dashboard .print-widget .template-text,
    .page.dashboard .print-widget .type-selector-text,
    .page.dashboard .print-widget .next-title {
        font-size: font-size(very-small);
    }

    .page.dashboard .print-widget .truncate {
        width: 130px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .page.dashboard .print-widget .print-widget-footer {
        position: absolute;
        bottom: 0;
        width: 100%;
    }

    .page.dashboard .print-widget .preview-label {
        text-align: center;
        font-size: font-size(very-normal);
        color: vt-color(dark-text);
        padding: 5px;
        margin-bottom: 3px;
        border: 1px solid vt-color(grid-general-border);
    }

    .page.dashboard .print-widget .switch-btn span {
        font-size: font-size(very-small);
    }

    .page.dashboard .print-widget .rank-block {
        height: 50px;
    }

    .page.dashboard .print-widget .print-widget-button {
        width: 40px;
        height: 40px;
        border-radius: 3px;
        position: relative;
        margin-right: 10px;
    }

    .page.dashboard .print-widget .print-widget-button i {
        font-size: 16px;
    }

    .page.dashboard .print-widget .print-widget-button:hover .print-widget-bubble,
    .page.dashboard .print-widget .print-widget-button.active .print-widget-bubble {
        background: vt-color(primary);
    }

    .page.dashboard .print-widget .print-widget-bubble {
        background: #e5e5e5;
        position: absolute;
        bottom: -5px;
        right: -5px;
        min-width: 15px;
        height: 15px;
        border-radius: 3rem;
        border: 2px solid #FFF;
    }

    .page.dashboard .print-widget .print-widget-bubble span {
        font-size: font-size(tiny);
        margin: 0 3px;
    }

    .page.dashboard .print-widget .print-widget-blank {
        margin-top: 30px;
        text-align: center;
    }

    .page.dashboard .print-widget .print-widget-blank i {
        font-size: 40px;
        color: #FFF;
    }

    .page.dashboard .print-widget .print-widget-blank span {
        font-size: 16px;
        line-height: 20px;
        color: vt-color(dark-text);
    }

    .page.dashboard .print-widget .print-widget-blank .circle {
        background: vt-color(light-primary);
        width: 100px;
        height: 100px;
        border-radius: 50%;
    }

    .page.dashboard .print-widget .print-widget-blank {
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    .page.dashboard .print-widget .print-widget-blank > div i {
        position: absolute;
    }

    .page.dashboard .print-widget .print-widget-blank > div {
        position: relative;
    }

    .page-dashboard .chart-widget #pie-chart{
        height: 200px !important;
    }

    .page.dashboard .chart-widget .item-chart {
        width: 250px;
    }

    .page.dashboard .chart-widget .item-text small {
        text-transform: uppercase;
        color: vt-color(dark-text, .3);
        font-size: font-size(very-small) !important;
    }

    .page.dashboard .chart-widget .item-text span,
    .page.dashboard .print-widget .item-text span {
        color: vt-color(dark-text);
        font-size: font-size(very-normal);
        font-weight: bold;
        text-transform: none;
    }

    .page.dashboard .print-widget .item-text .main-icon,
    .page.dashboard .chart-widget .item-text i {
        font-size: font-size(very-big) !important;
    }

    .page.dashboard .chart-widget .item-text span,
    .page.dashboard .chart-widget .item-text i {
        font-size: font-size(very-normal);
        text-transform: none;
    }

    .page.dashboard .link-widget {
        background: rgba(vt-color(primary), 0.9);
        color: vt-color(white-light);
        border-radius: 5px;
        cursor: pointer;
        box-shadow: 0 2px 5px 0 #9c9c9c !important;
    }

    .page.dashboard .link-widget:hover {
        background: vt-color(alt-primary);
    }

    .page.dashboard .scan-widget {
        cursor: pointer;
        border-radius: 5px;
        padding-top: 5px;
    }

    .page.dashboard .scan-widget .identifier {
        font-size: font-size(very-tiny);
        color: vt-color(dark-text, .3);
    }

    .page.dashboard .scan-widget .id-truncate {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .page.dashboard .scan-widget span {
        color: vt-color(dark-text);
    }

    .page.dashboard .scan-widget .title {
        font-size: font-size(very-small);
        font-weight: bold;
    }

    .page.dashboard .scan-widget .custom-input {
        border: transparent;
        border-bottom: 1px solid vt-color(primary);
        border-radius: 0;
        padding: 0;
        color: vt-color(primary);
        height: 18px;
    }

    .page.dashboard .scan-widget .custom-input::placeholder {
        opacity: .6;
        font-size: font-size(small);
    }

    .page.dashboard .input-group-text {
        background: rgba(vt-color(white-light), 0.2);
        border: transparent;
        border-bottom: 1px solid vt-color(white-light);
        border-radius: 0;
        color: vt-color(primary);
        padding: 7px;
    }

    .page.dashboard .input-group-prepend {
        margin-right: 0;
    }

    .page.dashboard .input-group-append {
        margin-left: 0;
    }

    .page.dashboard .input-group-prepend i {
        font-size: font-size(big);
    }

    .page.dashboard .info-widget.bg-dark {
        background: linear-gradient(
                        to right,
                        rgba(243, 145, 54, 0.9),
                        rgba(248, 175, 106, 0.9)
        );
    }

    .page.dashboard .vue-grid-item.bg-purple {
        background: linear-gradient(
                        to right,
                        rgba(146, 95, 189, 0.9),
                        rgba(163, 133, 187, 0.9)
        );
    }

    .page.dashboard .vue-grid-item.bg-green {
        background: linear-gradient(
                        to right,
                        rgba(68, 187, 164, 0.9),
                        rgba(118, 197, 181, 0.9)
        );
    }

    .page.dashboard .vue-grid-item.bg-yellow {
        background: linear-gradient(
                        to right,
                        rgba(242, 175, 41, 0.9),
                        rgba(253, 203, 103, 0.9)
        )
    }

    .page.dashboard .vue-grid-item.bg-red {
        background: linear-gradient(
                        to right,
                        rgba(252, 98, 116, 0.9),
                        rgba(250, 132, 146, 0.9)
        );
    }

    .page.dashboard .vue-grid-item.bg-blue {
        background: linear-gradient(
                        to right,
                        rgba(vt-color(primary), 0.9),
                        rgba(vt-color(primary), 0.9)
        );
    }

    .btn-hover-times {
        position: absolute;
        right: 3px;
        top: 3px;
        display: none;
        text-shadow: none;
        z-index: 2;
    }

    .btn-hover-edit {
        position: absolute;
        right: -6px;
        top: 27px;
        display: none;
        text-shadow: none;
        z-index: 2;
    }

    .info-widget:hover .btn-hover-times,
    .link-widget:hover .btn-hover-times,
    .scan-widget:hover .btn-hover-times,
    .chart-widget:hover .btn-hover-times,
    .print-widget:hover .btn-hover-times,
    .chart-widget:hover .btn-hover-edit {
        display: block;
    }

    .info-widget {
        color: vt-color(white-light);
        cursor: pointer;
        transition: 0.3s;
        @include general-card();
    }

    .info-widget:hover {
        background-color: rgba(255, 255, 255, 0.5);
    }

    .page.dashboard .item-header i,
    .page.dashboard .item-header span {
        font-size: 24px;
        cursor: pointer;
    }

    .page.dashboard .item-header a {
        color: vt-color(white-light);
        transition: 0.2s;
    }

    .page.dashboard .item-header a:hover {
        color: vt-color(dark-primary);
    }

    .page.dashboard .item-text span {
        text-transform: uppercase;
        font-size: font-size(small);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .modal-sample .modal-body {
        height: 400px !important;
    }

    .vue-grid-item {
        padding: 0.5rem;
        transition: none !important;

        > .vue-resizable-handle {
            background: inherit;
            padding: 0;
            margin: {
                right: 5px;
                bottom: 5px;
            }
            display: block;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 0 15px 15px;
            border-color: transparent transparent vt-color(light-grey) transparent;
        }

        > .vue-grid-title {
            color: vt-color(dark-text);
            font-size: 16px;
        }

        > .vue-grid-body {
            font-size: 14px;
            color: vt-color(dark-text);
        }

        &.vue-grid-placeholder {
            background-color: vt-color(light-primary);
        }
    }

    .vue-grid-item .container {
        cursor: default;
    }

    .grid-scroll {
        overflow-y: auto;
        background-image: url("../../img/dashboard-bg.png");
        height: 100%;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .widget-bar {
        background: rgba(73, 80, 110, 0.9);
        color: vt-color(white-light);
        width: 230px;
        height: 100%;
        position: absolute;
        right: -230px;
        z-index: 1;
        transition: 0.3s;
        box-shadow: 0 5px 10px 0 #9c9c9c;
    }

    .widget-bar .content-scroll {
        height: calc(100% - 55px);
        overflow-y: auto;
        overflow-x: hidden;
    }

    .module-header {
        background: rgb(70, 75, 97);
        font-size: font-size(very-small);
    }

    .module-items i {
        font-size: 25px;
    }

    .module-items .btn {
        background: rgba(73, 80, 110, 0.4);
        font-size: font-size(very-small);
        text-align: left;
        height: 50px;
    }

    .module-items .btn:hover {
        background: rgba(60, 63, 80, 0.8);
    }

    .module-items.btn-disabled .btn{
        cursor: not-allowed;
        opacity: .3;
        background: vt-color(base-text, .8) !important;
    }
    .widget-bar.alt {
        background: linear-gradient(to right, #4680ff, #76a1ff);
    }

    .widget-bar .header {
        border-top: 1px solid vt-color(primary);
        border-bottom: 1px solid vt-color(primary);
        background: vt-color(primary);
    }

    .widget-bar.alt .header {
        border-top: 1px solid vt-color(white);
        border-bottom: 1px solid vt-color(white);
        background: vt-color(primary);
    }

    .widget-bar .header span {
        color: vt-color(white);
        text-transform: uppercase;
        font-size: 0.9rem;
    }

    .widget-bar .content button {
        background: transparent;
        border-color: vt-color(white-light);
        color: vt-color(white-light);
    }

    .widget-bar.alt .content button {
        background: transparent;
        border-color: vt-color(white);
        color: vt-color(white);
    }

    .widget-bar .content button:hover {
        background: vt-color(primary);
        color: vt-color(white);
    }

    .bar-active {
        right: 0;
    }

    .hide {
        display: none;
    }

    .footer-bar {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 25px;
        border-top: 1px solid rgba(0, 0, 0, 0.125);
        transition: 0.3s;
    }

    .footer-bar.alt {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 25px;
        border-top: 1px solid #fff;
        transition: 0.3s;
    }

    .footer-bar.alt i {
        color: vt-color(white);
    }

    .footer-bar:hover {
        cursor: pointer;
        background: vt-color(primary);
    }

    .footer-bar:hover i {
        color: vt-color(white);
    }

    .setup-btn {
        position: absolute;
        bottom: 45px;
        right: 30px;
        width: 40px;
        height: 40px;
        z-index: 1;
    }

    .note-active {
        background: vt-color(primary) !important;
        color: vt-color(white) !important;
    }

    @media (max-width: 1300px) {
        .page.dashboard .info-widget .item-text span {
            width: 250px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .dashboard-container {
            margin: 1.5rem;
        }
    }

    @media (min-width: 1400px) {
        .dashboard-container {
            margin: 1.5rem 10rem;
        }
    }
</style>
